import React from "react";
import { Typography, Link } from "@material-ui/core";
import { HTMLtoReact } from "./HtmlToReact";
const config = {
    h2: (node, children, index) => (React.createElement(Typography, { key: index, variant: "h2" }, children)),
    p: (node, children, index) => (React.createElement(Typography, { key: index, variant: "body2", paragraph: true }, children)),
    li: (node, children, index) => (React.createElement(Typography, { variant: "body2", key: index },
        node.parent.name === "ol" ? `${index}. ` : "• ",
        children)),
    a: (node, children, index) => (React.createElement(Link, Object.assign({ key: index }, node.attribs), children)),
};
/**
 * A component that converts an raw HTML string into @material-ui/core components.
 *
 * @description Uses [`html-to-react`](https://github.com/aknuds1/html-to-react) under the hood.
 * You can pass additional config as a prop where the key is the HTML element and
 * the value is a replacement component.
 * @example
 * ---js
 * <HtmlToMui html={"<h3>Heading</h3>"} `config={{h3: (node, children) => <Typography variant="h3">{children}</Typography>}}`
 * ---
 */
export const HtmlToMui = ({ html, extraConfig = {}, children, }) => {
    return html ? (React.createElement(React.Fragment, null,
        children,
        React.createElement(HTMLtoReact, { html: html, config: { ...config, ...extraConfig } }))) : null;
};
